import { ExperimentGetter } from 'frontend/types';
import { SponsorLandingPagesTreatment } from 'frontend/types/landing/marketing';
import { track } from 'frontend/utils/analytics';

export const SPONSOR_PAGES: {
  EXPERIMENT: string;
  SHORT_PAYWALL_TREATMENT: SponsorLandingPagesTreatment;
} = {
  EXPERIMENT: 'sponsor_landing_pages_10_2021_v5',
  SHORT_PAYWALL_TREATMENT: 'short_paywall',
};

/** Time to wait before re-tracking an experiment */
const TRACKED_EXPERIMENT_WAIT = 30000; // 30 seconds

/** Used to log when an experiment was last tracked */
const trackedExperiments: { [key: string]: number } = {};

interface ExperimentData {
  experiment_name: string;
  [key: string]: any;
}

/**
 * Conditionally track the experiment. Only tracks an experiment once
 * per `TRACKED_EXPERIMENT_WAIT`
 */
function trackExperiment(experimentData: ExperimentData) {
  const now = Date.now();
  const { experiment_name: experimentName } = experimentData;
  const trackedTs = trackedExperiments[experimentName];
  if (!trackedTs || now - trackedTs > TRACKED_EXPERIMENT_WAIT) {
    track('user_saw_experiment_treatment', experimentData, { exclude: ['Amplitude'] });
    trackedExperiments[experimentName] = now;
  }
}

export function inExperimentGetter(experiments: any): ExperimentGetter {
  return (experimentName: string, treatmentName: string): boolean => {
    if (experiments && experiments[experimentName]) {
      const experiment = experiments[experimentName];
      const experimentData: ExperimentData = {
        experiment_name: experimentName,
        ...experiment,
      };
      trackExperiment(experimentData);
      return experiment.treatment_name === treatmentName;
    }

    // Experiment isn't live yet, but we're checking for control
    return !experiments[experimentName] && treatmentName === 'control';
  };
}
